import getCookieByName from '../helpers/getCookieByName'

function parseRedirectAfterGDPRCookie({ state }) {
  let redirectAfterGDPR = getCookieByName('redirectAfterGDPR')
  if (redirectAfterGDPR) {
    state.set('app.redirectAfterGDPR', true)
  }
}

export default parseRedirectAfterGDPRCookie



// WEBPACK FOOTER //
// ./src/modules/app/actions/parseRedirectAfterGDPRCookie.js